import { MouseEvent, TouchEvent, useRef } from 'react';
import playingCards from '../assets/playing_cards.svg';
import { CardSuit, CardValue } from '../interface/game';
import './Card.css';

export interface CardDataBase {
  cardId: string;
  draggable: boolean;
  onCardDrag: (cardId: string, xOff: number, yOff: number, xpos?: number, ypos?: number) => void;
  onCardDragMove: (xpos: number, ypos: number) => void;
}

export interface CardDataFaceUp extends CardDataBase {
  suit: CardSuit;
  value: CardValue;
  faceUp: true;
}

export interface CardDataFaceDown extends CardDataBase {
  faceUp: false;
}

export type CardData = CardDataFaceUp | CardDataFaceDown;

export type CardProperties = React.SVGProps<SVGSVGElement> & CardData;

export function Card(props: CardProperties) {
  const ref = useRef<HTMLDivElement>(null);
  const cardIconId = props.faceUp
    ? `${playingCards}#${props.value.toLowerCase()}-${props.suit.toLowerCase()}`
    : `${playingCards}#face-down`;
  const classNames = `${props.className} card-component`;

  function handleDrag(xOff: number, yOff: number, xpos?: number, ypos?: number) {
    if (props.draggable) {
      props.onCardDrag(props.cardId, xOff, yOff, xpos, ypos);
    } else {
      return true;
    }
  }


  function handleMouseDown(e: MouseEvent) {
    handleDrag(e.nativeEvent.offsetX, e.nativeEvent.offsetY)
  }

  function handleTouchStart(e: TouchEvent<SVGSVGElement> ) {
    console.log(`Card: Touch Start ${e.touches[0].clientX} ${e.touches[0].clientY}`);
    const touch = e.touches[0];
    handleDrag(0,0, touch.clientX, touch.clientY);
  }

  function handleTouchMove(e: TouchEvent<SVGSVGElement> ) {
    props.onCardDragMove(e.touches[0].clientX, e.touches[0].clientY);
  }

  return <div 
    ref={ref}><svg 
    style={props.style} 
    className={classNames} 
    onMouseDown={handleMouseDown}
    onTouchStart={handleTouchStart}
    onTouchMove={handleTouchMove}
  >
    <use xlinkHref={cardIconId}></use>
  </svg></div>
}


